export default __webpack_public_path__ + "static/meta-backstage-fb493a687466f9a1c709264895156991.png";